import React, { Component, Fragment } from 'react';
import { CloseCircleFilled, QuestionCircleOutlined, PlusCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { Select, Tooltip } from 'antd';
import { createPortal } from 'react-dom';
import Panel from '@/components/Panel';
import TreeSelect from '../../../../components/TreeSelect';
import { getPortByTouchstone } from '../../../../services/helper/getPortByTouchstone';
import Model from './preLayoutModel'
import { getTreeSelectList, getTouchstoneParse, getPkgSpiceModelList } from '../../../../services/Cascade/library';
import { TOUCHSTONE, SPICE } from '../../../../services/Cascade/constants';
import { PreLayoutModel } from '../../../../services/Cascade/prelayout';
import '../index.css'

const SPICE_TOUCHSTONE = "SPICE / Touchstone"
const modelTypeOptions = [SPICE_TOUCHSTONE]
class PreLayoutModelPanel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      files: [],
      ports: [],
      fileList: [],
      selectFileList: [],
      modelType: SPICE_TOUCHSTONE
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentDidMount() {
    this.initData()
  }

  componentDidUpdate(prevProps) {
    const { customSpiceList = [], customTouchstoneList = [] } = this.props;
    if (customSpiceList.length !== prevProps.customSpiceList.length || customTouchstoneList.length !== prevProps.customTouchstoneList.length) {
      this.initData()
    }
  }

  initData = () => {
    const { customSpiceList, customTouchstoneList, model, powerNets } = this.props;
    const fileList = [...customSpiceList, ...customTouchstoneList].map(item => getTreeSelectList(item));
    const preLayoutModel = new PreLayoutModel({
      files: model && model.files ? model.files : [],
      ports: model && model.ports ? model.ports : [],
      powerNets,
    });
    this.setState({
      files: preLayoutModel.files,
      ports: preLayoutModel.ports,
      fileList
    }, () => {
      this.getFileAndParse(preLayoutModel.files);
    });
  }

  getFileAndParse = async (files) => {
    let _selectFileList = [];
    for (let index = 0; index < files.length; index++) {
      const file = files[index];
      let fileInfo = {
        modelKey: `${index + 1}`,
        fileName: file ? file.fileName : "",
        libraryId: file ? file.libraryId : "",
        type: file ? file.type : "",
        subckt: file ? file.subckt : "",
        nodes: [],
        notes: []
      };

      if (file.type === SPICE) {
        try {
          const res = await getPkgSpiceModelList(file.libraryId, file.fileName, "SPICE");
          if (res && res.models && Array.isArray(res.models)) {
            fileInfo.subcktList = [...res.models];
            if (fileInfo.subckt) {
              const subcktInfo = fileInfo.subcktList.find(item => item.name === fileInfo.subckt)
              fileInfo.nodes = subcktInfo ? subcktInfo.ports : []
            } else if (fileInfo.subcktList.length === 1) {
              fileInfo.subckt = fileInfo.subcktList[0].name;
              fileInfo.nodes = fileInfo.subcktList[0].ports;
            }
          }
        } catch (error) {
          console.error(error);
        }
      } else if (file.type === TOUCHSTONE) {
        fileInfo.nodes = getPortByTouchstone(file.fileName);
        const tsInfo = await getTouchstoneParse(file.libraryId, file.fileName);
        fileInfo.notes = tsInfo ? tsInfo.ports : []
      }
      _selectFileList.push(fileInfo);
    }
    this.setState({ selectFileList: _selectFileList });
  }

  closeModal = () => {
    const { ports, files } = this.state
    this.props.closeModal(files, ports)
  }

  onRef = (ref) => {
    this.modelChild = ref;
  }

  selectSpiceSubckt = (subcktName, index) => {
    const { selectFileList } = this.state;
    const _selectFileList = [...selectFileList];
    const prevFileInfo = selectFileList[index]

    let fileInfo = { ..._selectFileList[index] };
    if (!fileInfo || !fileInfo.subcktList) return;

    const selectedSubckt = fileInfo.subcktList.find(subckt => subckt.name === subcktName);
    if (!selectedSubckt) return;

    fileInfo.subckt = selectedSubckt.name;
    fileInfo.nodes = selectedSubckt.ports || [];

    _selectFileList[index] = fileInfo;
    this.updatePortList(prevFileInfo)
    this.updateFiles(_selectFileList);
    this.setState({ selectFileList: _selectFileList }, () => {
      // if (this.modelChild && this.modelChild.autoSetPorts) {
      //   this.modelChild.autoSetPorts(fileInfo)
      // }
    });
  };

  deleteFileSelect = (target, index) => {
    const { selectFileList } = this.state;
    const _selectFileList = [...selectFileList];
    const prevFileInfo = selectFileList[index]
    if (target === 'file') {
      _selectFileList[index] = {
        modelKey: `${index + 1}`,
        nodes: [],
        fileName: '',
        libraryId: '',
        subckt: '',
        subcktList: [],
      };
    } else if (target === 'subckt') {
      _selectFileList[index] = {
        ..._selectFileList[index],
        nodes: [],
        subckt: '',
      };
    }
    this.updatePortList(prevFileInfo)
    this.updateFiles(_selectFileList);
    this.setState({ selectFileList: _selectFileList });
  }

  addNewFileSelect = (e) => {
    e && e.stopPropagation()
    const { selectFileList } = this.state;
    let _selectFileList = [...selectFileList];
    if (_selectFileList.length === 0) {
      _selectFileList = [
        {
          modelKey: "1",
          nodes: [],
          fileName: '',
          libraryId: '',
          subckt: '',
          subcktList: []
        },
        {
          modelKey: "2",
          nodes: [],
          fileName: '',
          libraryId: '',
          subckt: '',
          subcktList: [],
        }
      ];
    } else {
      const newModelKey = String(_selectFileList.length + 1);
      _selectFileList.push({
        modelKey: newModelKey,
        nodes: [],
        fileName: '',
        libraryId: '',
        subckt: '',
        subcktList: [],
      });
    }
    this.updateFiles(_selectFileList);
    this.setState({ selectFileList: _selectFileList });
  }

  updateFiles = (selectedFiles) => {
    const files = selectedFiles.map(item => {
      return {
        fileName: item.fileName || "",
        libraryId: item.libraryId || "",
        modelKey: item.modelKey || "1",
        subckt: item.subckt || "",
        type: item.type || ""
      }
    })
    this.setState({
      files
    })
  }

  selectModelFile = async (key, index) => {
    const { selectFileList, fileList } = this.state;
    const _selectFileList = [...selectFileList];
    const prevFileInfo = selectFileList[index];

    const name = key.id ? key.name : key;
    const model = key.id ? { ...key } : fileList.find(item => item.name === name);

    if (!model) return;

    let fileInfo = {
      modelKey: `${index + 1}`,
      fileName: name,
      libraryId: model.id || "",
      type: model.modelType,
      subckt: "",
      nodes: [],
      notes: []
    };

    if (model.modelType === SPICE) {
      try {
        const res = await getPkgSpiceModelList(model.id, model.name, "SPICE");
        if (res && res.models && Array.isArray(res.models)) {
          fileInfo.subcktList = [...res.models];
          if (fileInfo.subcktList.length === 1) {
            fileInfo.subckt = fileInfo.subcktList[0].name;
            fileInfo.nodes = fileInfo.subcktList[0].ports;
          }
        }
      } catch (error) {
        console.error(error);
      }
    } else if (model.modelType === TOUCHSTONE) {
      fileInfo.nodes = getPortByTouchstone(name);
      const tsInfo = await getTouchstoneParse(model.id, name);
      fileInfo.notes = tsInfo ? tsInfo.ports : []
    }

    this.updatePortList(prevFileInfo)
    _selectFileList[index] = fileInfo;
    this.updateFiles(_selectFileList);
    this.setState({
      selectFileList: _selectFileList
    }, () => {
      // if (this.modelChild && this.modelChild.autoSetPorts) {
      //   this.modelChild.autoSetPorts(fileInfo)
      // }
    });
  };

  updatePortList = (prevFileInfo) => {
    if (!prevFileInfo) return;
    const { ports } = this.state;
    const _ports = JSON.parse(JSON.stringify(ports));
    _ports.forEach(group => {
      ['icPorts', 'pmicPorts'].forEach(type => {
        group[type].forEach(port => {
          if (port.libraryId === prevFileInfo.libraryId && port.modelKey === prevFileInfo.modelKey) {
            port.libraryId = '';
            port.subckt = '';
            port.node = '';
            port.modelKey = '';
            port.fileName = '';
          }
        });
      });
    });

    this.setState({ ports: _ports }, () => {
      // this.modelChild && this.modelChild.initPortList()
    });
  }

  deleteModelSelect = (index) => {
    const { selectFileList, ports } = this.state;
    const _selectFileList = [...selectFileList];
    const prevFileInfo = selectFileList[index]
    if (index < 0 || index >= _selectFileList.length) return;
    _selectFileList.splice(index, 1);
    const modelKeyMap = {};
    _selectFileList.forEach((file, i) => {
      modelKeyMap[file.modelKey] = String(i + 1);
      file.modelKey = String(i + 1);
    });

    const _ports = JSON.parse(JSON.stringify(ports));
    _ports.forEach(group => {
      ['icPorts', 'pmicPorts'].forEach(type => {
        group[type].forEach(port => {
          if (port.libraryId === prevFileInfo.libraryId && port.modelKey === prevFileInfo.modelKey) {
            port.libraryId = '';
            port.subckt = '';
            port.node = '';
            port.modelKey = '';
            port.fileName = '';
          } else if (port.libraryId && modelKeyMap[port.modelKey]) {
            port.modelKey = modelKeyMap[port.modelKey];
          }
        });
      });
    });

    if (!_selectFileList.length) {
      // this.initPairs()
    }

    this.updateFiles(_selectFileList);
    this.setState({ selectFileList: _selectFileList, ports: _ports });
  };

  onRef = (ref) => {
    this.modelChild = ref;
  }

  updatePorts = (ports) => {
    this.setState({
      ports
    })
  }

  changeModelType = (value) => {
    this.setState({
      modelType: value
    })
  }

  isFileExist = (list, libraryId) => {
    return list.some(file =>
      file.id === libraryId ||
      (Array.isArray(file.children) && this.isFileExist(file.children, libraryId))
    );
  };

  renderDialog = () => {
    const { fileList, nodes, selectFileList, ports, modelType } = this.state
    const content = (
      <Panel
        className='cascade-pre-layout-model-panel'
        id='pre-layout-model-panel'
        title={'Pre-Layout Model'}
        onCancel={this.closeModal}
        zIndex={2000}
        width={794}
        minWidth={300}
        minHeight={200}
        maxHeight={800}
        position='panel-center-left'
        draggable
        overflow={"auto"}
      >
        <div className='cascade-model-content'>
          <div className='cascaede-model-select'>
            <span>Model Type</span>
            <Select
              value={modelType}
              onChange={this.changeModelType}
              className='cascaede-model-selection'
              popupClassName='netlist-model-dropdown'
              getPopupContainer={() => document.getElementById('root')}
              options={modelTypeOptions.map(item => ({
                value: item,
                label: item
              }))}
            />
          </div>
          {(selectFileList.length > 0 ? selectFileList : [{}]).map((item, index) => {
            const fileNotFound = item.libraryId && !this.isFileExist(fileList, item.libraryId) ? true : false;
            return <div className='cascaede-model-select' key={index}>
              <div className='spice-model-file-add-box'>
                {index === 0 && <Fragment>
                  <span>Model File</span>
                  <PlusCircleOutlined
                    title={'Add new file'}
                    className='spice-model-add-file-icon'
                    onClick={(e) => { this.addNewFileSelect(e) }}
                  />
                </Fragment>}
              </div>
              <TreeSelect
                showSearch
                value={item.fileName || ''}
                onSelectItem={(key) => this.selectModelFile(key, index)}
                className={`cascaede-model-selection ${item.type === SPICE ? "cascaede-model-selection-50" : ""}`}
                popupClassName='netlist-model-dropdown'
                popupMatchSelectWidth={false}
                allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.deleteFileSelect('file', index)} /> }}
                getPopupContainer={() => document.getElementById('root')}
                fileList={fileList}
                selected={`${item.libraryId || ''}-${item.fileName || ''}`}
                selectedkey={"key"}
                suffixIcon={fileNotFound ? <Tooltip
                  title={`The corresponding file was not found, please choose again.`}
                ><QuestionCircleOutlined className='aurora-file-check-icon' /></Tooltip> : null}
              />
              {item.type === SPICE && (
                <Select
                  style={{ marginLeft: "10px" }}
                  value={item.subckt || ''}
                  onSelect={(key) => this.selectSpiceSubckt(key, index)}
                  className='cascaede-model-selection cascaede-model-selection-50'
                  popupClassName='netlist-model-dropdown'
                  allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => { this.deleteFileSelect('subckt', index) }} /> }}
                  getPopupContainer={() => document.getElementById('root')}
                  options={(item.subcktList || []).map(subckt => ({
                    value: subckt.name,
                    label: subckt.name,
                    disabled: subckt.disabled,
                    title: subckt.disabled ? 'The number of ports should be two' : ''
                  }))}
                />
              )}
              {selectFileList.length > 0 &&
                <CloseOutlined
                  title="Delete Model"
                  onClick={(e) => this.deleteModelSelect(index)}
                  className="spice-netlist-model-title-pcb-delete-icon"
                />
              }
            </div>
          })}
          <Model
            onRef={this.onRef}
            nodes={nodes}
            selectFileList={selectFileList}
            ports={ports}
            updatePorts={this.updatePorts}
          />
        </div>
      </Panel>
    );
    return createPortal(content, this.dialogRoot);
  }

  render() {
    return <Fragment>
      {this.renderDialog()}
    </Fragment>
  }
}

export default PreLayoutModelPanel;
